/* eslint-disable no-debugger */
<template lang="pug">
  v-app
    v-app-bar(
      app
      color="white"
      prominent
      v-if="$router.currentRoute.path === '/'")    
      .d-flex.align-center
        v-img(
          alt="NuFi Logo"          
          contain
          src="@/assets/componentes-06.png"
          transition="scale-transition"
          width="300")    
    router-view      
</template>

<script>

export default {
  name: 'App',  

  data: () => ({
    //
  }),

  created() {
    const parts = window.location.href.split('token=');
    let token;    
    if (parts.length > 1) {
      token = parts[1];
    } else {
      window.location.replace(process.env.VUE_APP_LOGIN)
    }
    if(token.includes('#')) {
      token = token.split("#")[0] + '$$';
    }
    this.$store.commit("SET_TOKEN", token.substring(0,token.length - 2));
    this.$store.dispatch("userGet").then(response => {            
      if(response.status === 200) {
        this.$store.commit("SET_USER", response.data);
        this.$i18n.locale = response.data.locale;
      } else {
        window.location.replace(process.env.VUE_APP_LOGIN)
      }
    }).catch(() => {
      window.location.replace(process.env.VUE_APP_LOGIN)
    });
  },
};
</script>
